import { PARTNER_STATE } from './SkuItems.constants';
import {
  getCategoryId,
  getCategoryMenuId,
  getCategoryName,
  getItemCategoryIds,
  getItemId,
  getItemName,
  getMenuId,
  getMenuName,
  getPublished,
  isEnabledMenu,
  isVisibleSkuEntity,
} from './SkuMenuData.normalizers';

export const sortSelectedFirst = (options, selected) =>
  [...options].sort((a, b) => {
    if (a === selected) return -1;
    if (b === selected) return 1;
    return 0;
  });

export const getDefaultSelectedMenuId = menus => {
  const firstEnabledMenu = menus.find(isEnabledMenu);
  return getMenuId(firstEnabledMenu);
};

export const buildSkuMenuTree = ({ menus = [], categories = [], skuItems = [] }) => {
  const normalizedMenus = menus
    .map(menu => {
      const isUnavailable = menu?.partnerState === PARTNER_STATE.UNAVAILABLE;
      return {
        id: getMenuId(menu),
        name: getMenuName(menu),
        enabled: isUnavailable ? false : menu?.enabled ?? true,
        raw: menu,
      };
    })
    .filter(menu => Boolean(menu.id));

  const normalizedCategories = categories
    .map(category => {
      const isUnavailable = category?.partnerState === PARTNER_STATE.UNAVAILABLE;
      return {
        id: getCategoryId(category),
        menuId: getCategoryMenuId(category),
        name: getCategoryName(category),
        enabled: isUnavailable ? false : category?.enabled ?? true,
        raw: category,
      };
    })
    .filter(category => Boolean(category.id) && Boolean(category.menuId));

  const normalizedItems = skuItems
    .filter(isVisibleSkuEntity)
    .map(item => ({
      id: getItemId(item),
      name: getItemName(item),
      published: getPublished(item),
      enabled: item?.enabled ?? false,
      categoryIds: getItemCategoryIds(item),
      raw: item,
    }))
    .filter(item => Boolean(item.id));

  const itemsByCategoryId = normalizedItems.reduce((acc, item) => {
    item.categoryIds.forEach(categoryId => {
      const current = acc[categoryId] || [];
      current.push(item);
      acc[categoryId] = current;
    });
    return acc;
  }, {});

  const compareByName = (a, b) => (a.name || '').localeCompare(b.name || '');

  return normalizedMenus.map(menu => {
    const menuCategories = normalizedCategories
      .filter(category => category.menuId === menu.id)
      .sort(compareByName)
      .map(category => ({
        ...category,
        items: (itemsByCategoryId[category.id] || []).sort(compareByName),
      }));

    return {
      ...menu,
      categories: menuCategories,
    };
  });
};
